import { rootContainer } from '@servicetitan/react-ioc';
import { Log } from '@servicetitan/log-service';

/**
 * Binds the host's Log instance into the root IoC container so embedded MFEs
 * (InboxMfeLoader, CustomerMfeLoader, BookingConfigMfeLoader) resolve it via
 * web-components' Loader, which reads Log from the container tree with no
 * per-page Provider required. Guarded against being called more than once
 * (e.g. HMR re-running the App module).
 */
export function bindSharedLog(log: Log): void {
  if (!rootContainer.isBound(Log)) {
    rootContainer.bind(Log).toConstantValue(log);
  }
}
